<script lang="ts">
    import Select from './Select.svelte';
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import {
        TacticalPlanApi,
        type TacticalPlanResponseType,
    } from '../components/TacticalPlan/TacticalPlanApi';
    import { api } from '../../stores/api';
    import Spinner from './Spinner/Spinner.svelte';
    import { WeekSchedule } from '../utilities/WeekSchedule';
    import { debug } from '../../stores/store';
    import { filterOnlyTacticalPlansForDay } from '../utilities/TacticalPlans';

    export let selectedTacticalPlan: number | null;
    export let day: string;
    export let onChange: (selected: number | null) => void;
    export let tacticalPlans: TacticalPlanResponseType[] = [];

    let items: { id: string; label: string }[] = [];
    let loading: boolean = true;
    let error: string = '';

    onMount(() => {
        if (tacticalPlans.length === 0) {
            Promise.all([TacticalPlanApi.getAll(get(api))])
                .then(response => {
                    tacticalPlans = response[0];
                })
                .catch(err => {
                    error = err;
                })
                .finally(() => {
                    loading = false;
                });
        } else {
            loading = false;
        }
    });

    onChange(selectedTacticalPlan);

    $: {
        // items = filterOnlyTacticalPlansForDay(tacticalPlans, day);
        if (!loading) {
            items = tacticalPlans.map(tp => {
                return {
                    id: tp.id.toString(),
                    label: tp.name,
                };
            });
            // if selectedTacticalPlan is not in items, then set it to first item
            // @ts-ignore
            if (
                (selectedTacticalPlan &&
                    items.filter(i => i.id === selectedTacticalPlan.toString()).length === 0) ||
                selectedTacticalPlan === null
            ) {
                console.log('selectedTacticalPlan not in items, setting to first item');
                selectedTacticalPlan = (items.length > 0 && parseInt(items[0].id)) || -10;
                onChange(selectedTacticalPlan);
            }
        }
    }
</script>

{#if loading}
    <Spinner />
{:else}
    {#if error}
        {error}
    {/if}
    <Select
        {items}
        selected={(selectedTacticalPlan && selectedTacticalPlan.toString()) || ''}
        useDefaultStyles={true}
        onChange={s => {
            let output = (s !== '' && parseInt(s)) || null;
            onChange(output);
            return true;
        }}
    />

    {#if $debug}
        <div>
            SelectedPlanId: {selectedTacticalPlan}
            Day: {day}
            Items: {JSON.stringify(items)}
        </div>
    {/if}
{/if}

<style>
    :global(.input-small) {
        width: 200px;
    }
</style>
